import { InjectionToken } from '@angular/core';

export const APP_READONLY_MODE = new InjectionToken<boolean>(
  'The application is read-only. All creation and editing dialogs will be skipped.',
  { providedIn: 'root', factory: (): boolean => false }
);

export const PAGE_SCROLL_CONTAINER_SELECTOR = new InjectionToken<string>(
  'CSS selector of the element that scrolls the page instead of the window. Null when the window scrolls.',
  { providedIn: 'root', factory: (): string => null }
);
